var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        size: "md",
        title: "What would you like to reset?",
      },
      on: { closed: _setup.closeModal },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.closeModal },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: { text: "Reset", variant: "primary" },
                    on: { click: _setup.onConfirmHandler },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        _setup.CRadio,
        {
          staticClass: "mb-2",
          attrs: { "input-value": false, bordered: "" },
          model: {
            value: _setup.resetWholePreview,
            callback: function ($$v) {
              _setup.resetWholePreview = $$v
            },
            expression: "resetWholePreview",
          },
        },
        [
          _c("div", { staticClass: "radio-content" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v("Design Elements Only"),
            ]),
            _vm._v(
              "\n            Resets design elements from Step 1 while maintaining your background and layers added for your Preview.\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.CRadio,
        {
          attrs: { "input-value": true, bordered: "" },
          model: {
            value: _setup.resetWholePreview,
            callback: function ($$v) {
              _setup.resetWholePreview = $$v
            },
            expression: "resetWholePreview",
          },
        },
        [
          _c("div", { staticClass: "radio-content" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Whole Preview")]),
            _vm._v(
              "\n            Resets the entire preview to adjust height, width, background and layers added. Elements that belong\n            only to your preview will be removed.\n        "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }